import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.css'],
})
export class DetalleComponent implements OnInit {
  loading: boolean = false;
  success: boolean = false;
  isthereChanges: boolean = false;
  myForm: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<DetalleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.myForm = this.fb.group({
      Abonar: new FormControl(null, Validators.required),
      saldoDisponible: new FormControl(null),
      montoInvoice: new FormControl(null),
    });

    console.log(data);
  }

  ngOnInit(): void {}

  DisableSubmit() {
    if (
      (this.myForm.get('comisionBancaria')?.value === true &&
        !this.myForm.invalid) ||
      this.myForm.get('OSOC')?.value === true
    ) {
      return false;
    }
    return true;
  }

  onSave() {
    if (!this.loading) {
      this.loading = true;
      this.Submit();
    }
  }
  Submit() {}
  OnClose() {
    this.dialogRef.close({
      success: this.success,
      isthereChanges: this.isthereChanges,
    });
  }
  onCancel() {
    this.OnClose();
  }

  ngOnDestroy(): void {
    this.OnClose();
  }
}
